export default "__VITE_ASSET__B912pE13__"